import util from "./_util";

const { request } = util;

export default {
  /**
   * 单位类型分类
   * */
  // 添加
  companyAdd(data) {
    return request.post("/EntrustCompany/save_entrust_company", data);
  },

  // 删除
  companyDel(params) {
    return request.post("/EntrustCompany/delete_entrust_companys" + params);
  },

  // 修改
  companyUpdate(params) {
    return request.post("/EntrustCompany/save_entrust_company", params);
  },

  // 获取单位类型
  companyGetAll() {
    return request.get("/dwgl/get_all");
  },

  // 根据ID查询详情
  companyGetById(params) {
    return request.get("/dwgl/get_by_id", params);
  },
 
};
